// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search_txt {
  text-align: center;
  color: #091f47;
  opacity: 0.5;
  font-size: 12px;
}

.type_image {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 10px;
  justify-content: space-evenly;
  margin-top: 1vh;
  padding: 20px;
  box-sizing: border-box;
}
.type_image .type {
  width: -moz-fit-content;
  width: fit-content;
  min-width: 45%;
  height: 156px;
  background: #4e4e4e;
  text-align: center;
  color: #fff;
  background-size: cover;
  background-position: top;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: inset -1px -20px 20px 0px black;
}
.type_image .type label {
  font-weight: bold;
  text-shadow: 1px 1px black;
  line-height: 275px;
  color: white;
  font-size: 75%;
  white-space: nowrap;
  text-transform: uppercase;
}
.type_image .large {
  width: 94%;
  min-height: 150px;
}
.type_image h3 {
  font-size: 12px;
  text-align: center;
  display: block;
  width: 100%;
  padding-left: 10px;
  letter-spacing: 2px;
  text-transform: lowercase;
  margin: 4px;
  margin-top: 6px;
}

.no_seller_acc {
  width: 80%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20vh;
  color: #ab8774;
}
.no_seller_acc button {
  padding: 20px;
  margin-top: 30px;
  background: #dbb49f;
  border: none;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/add-listing/add-listing.page.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACI,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EAEA,2CAAA;AAAR;AAEQ;EACI,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AAAZ;AAII;EACI,UAAA;EACA,iBAAA;AAFR;AAKI;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAHR;;AAOA;EACI,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAJJ;AAMI;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAJR","sourcesContent":[".search_txt {\n    text-align: center;\n    color: #091f47;\n    opacity: 0.5;\n    font-size: 12px;\n}\n\n.type_image {\n    display: flex;\n    flex-wrap: wrap;\n    grid-gap: 10px;\n    justify-content: space-evenly;\n    margin-top: 1vh;\n    padding: 20px;\n    box-sizing: border-box;\n\n    .type {\n        width: fit-content;\n        min-width: 45%;\n        height: 156px;\n        background: #4e4e4e;\n        text-align: center;\n        color: #fff;\n        background-size: cover;\n        background-position: top;\n        border-radius: 4px;\n        cursor: pointer;\n\n        box-shadow: inset -1px -20px 20px 0px black;\n\n        label {\n            font-weight: bold;\n            text-shadow: 1px 1px black;\n            line-height: 275px;\n            color: white;\n            font-size: 75%;\n            white-space: nowrap;\n            text-transform: uppercase;\n        }\n    }\n\n    .large {\n        width: 94%;\n        min-height: 150px;\n    }\n\n    h3 {\n        font-size: 12px;\n        text-align: center;\n        display: block;\n        width: 100%;\n        padding-left: 10px;\n        letter-spacing: 2px;\n        text-transform: lowercase;\n        margin: 4px;\n        margin-top: 6px;\n    }\n}\n\n.no_seller_acc {\n    width: 80%;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 20vh;\n    color: #ab8774;\n\n    button {\n        padding: 20px;\n        margin-top: 30px;\n        background: #dbb49f;\n        border: none;\n        color: #fff;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
